/* eslint-disable global-require */

const projects = [
  {
    id: 3,
    title: 'Choice Roulette',
    description:
      'A fun little app that allows you to add options and then randomly select one of them.',
    image: require('../assets/projects/pj19 - choice.png'),
    link: 'https://github.com/alexpuente0/choice_roulette',
    tags: ['React', 'JS', 'UI'],
    year: '2024',
  },
  {
    id: 1,
    title: 'Raul Sergio — Master Hair Stylist',
    description:
      'A personal website for Raul Sergio, a world-class master hair stylist. Showcases his work and lets users request appointments.',
    image: require('../assets/projects/pj17 - raulsergio.png'),
    link: 'https://github.com/alexpuente0/raul_sergio',
    tags: ['React', 'Client'],
    year: '2024',
  },
  {
    id: 2,
    title: 'Family Calendar',
    description:
      'A web app to prevent scheduling clashes and coordinate my family’s commitments.',
    image: require('../assets/projects/pj16 - calfam.png'),
    link: 'https://github.com/alexpuente0/calendario-familiar',
    tags: ['React', 'API'],
    year: '2024',
  },
  {
    id: 4,
    title: 'Budget Wizard',
    description:
      'An object-based personal finance mobile app where each user can log in and register expenses across categories or groups.',
    image: require('../assets/projects/pj15 - bgwz.png'),
    link: 'https://github.com/alexpuente0/budget_wizard',
    tags: ['Rails', 'Mobile'],
    year: '2023',
  },
  {
    id: 5,
    title: 'Recipes App',
    description:
      'An object-based personal recipe app where each user can log in and enter recipes while using an ingredients inventory and a shopping list for the missing ones.',
    image: require('../assets/projects/pj14 - recp.png'),
    link: 'https://github.com/alexpuente0/recipes_rails',
    tags: ['Rails', 'Ruby'],
    year: '2023',
  },
  {
    id: 6,
    title: 'Blog Page',
    description:
      'A generic blog built with Ruby on Rails. After login, users can create posts, comment, and like. It doubles as an API.',
    image: require('../assets/projects/pj13 - blog.png'),
    link: 'https://github.com/alexpuente0/rails_blog',
    tags: ['Rails', 'API'],
    year: '2023',
  },
  {
    id: 7,
    title: 'Air Quality Monitor',
    description:
      'Single-page app built with React using a global air-quality API. Search a city and get the current AQI.',
    image: require('../assets/projects/pj10 - airQ.png'),
    link: 'https://github.com/alexpuente0/air-quality-monitor',
    tags: ['React', 'API'],
    year: '2023',
  },
  {
    id: 8,
    title: 'Space Traveler’s Hub',
    description:
      'React web app that lets users book rockets and sign up for missions from the SpaceX API.',
    image: require('../assets/projects/pj9 - rocket.png'),
    link: 'https://github.com/alexpuente0/react-spacex',
    tags: ['React', 'Redux', 'API'],
    year: '2023',
  },
  {
    id: 9,
    title: 'BookStore CMS',
    description:
      'A single-page app to keep track of which books you have started or finished reading. Data is stored on an external API.',
    image: require('../assets/projects/pj8 - store.png'),
    link: 'https://github.com/alexpuente0/bookstore-react',
    tags: ['React', 'Redux'],
    year: '2023',
  },
  {
    id: 10,
    title: 'MathMagicians',
    description:
      'A single-page React app with a homepage, an interactive calculator, and a math-related quote.',
    image: require('../assets/projects/pj7 - math.png'),
    link: 'https://github.com/alexpuente0/mathmagicians',
    tags: ['React'],
    year: '2022',
  },
  {
    id: 11,
    title: 'Leaderboard',
    description:
      'A simple fun “game” where you submit your name and get a random score. Scores are listed in descending order; data stored in an API.',
    image: require('../assets/projects/pj6 - lead.png'),
    link: 'https://github.com/alexpuente0/Leaderboard',
    tags: ['JS', 'API'],
    year: '2022',
  },
  {
    id: 12,
    title: 'To-do List',
    description:
      'An interactive list of tasks where you can add, complete, and edit items.',
    image: require('../assets/projects/pj5 - todo.png'),
    link: 'https://github.com/alexpuente0/todo_list',
    tags: ['JS', 'UI'],
    year: '2022',
  },
  {
    id: 13,
    title: 'Awesome Books',
    description:
      'A single-page app built with JS, HTML, and CSS. Add and remove books from a list; persisted in local storage.',
    image: require('../assets/projects/pj4 - awbk.png'),
    link: 'https://github.com/alexpuente0/awesome_books_es6',
    tags: ['JS', 'HTML'],
    year: '2022',
  },
  {
    id: 14,
    title: 'Unlimited Love — Launch Party',
    description:
      'A fan-made website celebrating the mock launch party for the 2022 Red Hot Chili Peppers album. Most assets designed in Photoshop.',
    image: require('../assets/projects/pj3 - ulov.png'),
    link: 'https://github.com/alexpuente0/Capstone_festival',
    tags: ['HTML', 'CSS', 'Design'],
    year: '2022',
  },
];

export default projects;
